<template>
  <div>
    <b-modal
      id="modal-edit"
      size="xl"
      centered
      title="Edit Surat Perintah Karyawan"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            No. Surat Perintah <span class="text-danger">*</span>
          </template>
          <b-form-input
            type="text"
            disabled
            v-model="$v.dataEdit.nomorSuratPerintah.$model"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Data Karyawan <span class="text-danger">*</span>
          </template>
          <b-form-input
            type="text"
            v-model="data.namaKaryawan"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label> No. Surat Perjanjian </template>
          <b-form-input
            type="text"
            v-model="noSuratPerjanjian"
            disabled
          ></b-form-input>
        </b-form-group>

        <!-- <b-form-group label="Nama Mitra" label-cols-md="3">
          <Multiselect
            v-model="$v.dataEdit.mitraIdEdit.$model"
            :state="checkIfValid('mitraIdEdit')"
            :options="dataMitra"
            @input="getKoordinators(dataEdit.mitraIdEdit), setPenempatan()"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>

        <b-form-group label="Nama Koordinator" label-cols-md="3">
          <Multiselect
            v-model="dataEdit.koordinatorIdEdit"
            :options="koordinator"
            @input="getCabangs(dataEdit.koordinatorIdEdit), setPenempatan()"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKoordinator"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group> -->

        <b-form-group label="Nama Cabang" label-cols-md="3">
          <Multiselect
            v-model="dataEdit.cabangIdEdit"
            :options="dataCabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCabang"
            placeholder="-- Pilih --"
            @input="setPenempatan()"
          ></Multiselect>
        </b-form-group>
        <!-- @input="getCapems(dataEdit.cabangIdEdit), setPenempatan()" -->

        <!-- <b-form-group label="Nama Capem" label-cols-md="3">
          <Multiselect
            v-model="dataEdit.capemIdEdit"
            :options="capem"
            @input="setPenempatan()"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCapem"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group> -->

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Tanggal Mulai Kontrak <span class="text-danger">*</span>
          </template>
          <DatePicker
            v-model="dataEdit.tanggalKontrak"
            style="width: 100%"
            :placeholder="data.tanggalKontrakEdit"
            @input="setExpire()"
          ></DatePicker>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Durasi Kontrak (bulan) <span class="text-danger">*</span>
          </template>
          <b-form-input
            type="number"
            v-model="$v.dataEdit.masaBerlakuKontrak.$model"
            :state="checkIfValid('masaBerlakuKontrak')"
            style="width: 100%"
            @input="setExpire()"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Selesai Kontrak <span class="text-danger">*</span>
          </template>
          <DatePicker
            v-model="dataEdit.jatuhTempoKontrak"
            style="width: 100%"
            :placeholder="
              $moment(dataEdit.jatuhTempoKontrak).format('DD-MM-YYYY')
            "
          ></DatePicker>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Jabatan Manajemen <span class="text-danger">*</span>
          </template>
          <Multiselect
            v-model="$v.dataEdit.posisiManajemenId.$model"
            :options="manajemen"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="id"
            @input="
              (dataEdit.namaPejabatManajemen =
                dataEdit.posisiManajemenId.namaManajemen),
                (dataEdit.posisiManajemen =
                  dataEdit.posisiManajemenId.jabatanManajemen)
            "
            label="jabatanManajemen"
            placeholder="-- Pilih Posisi --"
          ></Multiselect>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Nama Manajemen <span class="text-danger">*</span>
          </template>
          <b-form-input
            size="lg"
            type="text"
            v-model="dataEdit.namaPejabatManajemen"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Penempatan <span class="text-danger">*</span>
          </template>
          <b-form-input
            size="lg"
            type="text"
            v-model="dataEdit.penempatan"
            style="width: 100%"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          Batal
        </b-button>
        <b-button
          variant="primary"
          @click="simpan()"
          :disabled="!isValid || busy"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["karyawan", "data", "dataCabang", "edit"],
  name: "modalEdit",
  data() {
    return {
      dataEdit: {
        tanggalKontrak: "",
        masaBerlakuKontrak: "",
        jatuhTempoKontrak: "",
        dataKaryawanId: "",
        mitraIdEdit: "",
        koordinatorIdEdit: "",
        cabangIdEdit: "",
        capemIdEdit: "",
        nomorSuratPerintah: "",
        suratPerjanjianKerjaId: "",
        posisiManajemenId: "",
        namaPejabatManajemen: "",
        posisiManajemen: "",
      },
      noSuratPerjanjian: "",
      cabang: [],
      koordinator: [],
      capem: [],
      manajemen: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataEdit, null, 4);
    },
    isValid() {
      return !this.$v.dataEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataEdit.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataEdit: {
      masaBerlakuKontrak: {
        required,
      },
      mitraIdEdit: {
        // required,
      },
      // koordinatorIdEdit: {
      //   required,
      // },
      nomorSuratPerintah: {
        required,
      },
      posisiManajemenId: {
        // required,
      },
    },
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        let vm = this
        vm.dataEdit = {
          tanggalKontrak: "",
          masaBerlakuKontrak: "",
          jatuhTempoKontrak: "",
          dataKaryawanId: "",
          mitraIdEdit: "",
          koordinatorIdEdit: "",
          cabangIdEdit: "",
          capemIdEdit: "",
          nomorSuratPerintah: "",
          suratPerjanjianKerjaId: "",
          posisiManajemenId: "",
          namaPejabatManajemen: "",
          posisiManajemen: "",
          penempatan: "",
        };
        // console.log(vm.data.mitraIdEdit, "ini mitra");
        
        for (let i = 0; i < vm.dataCabang.length; i++) {
          if (vm.dataCabang[i].cabangId == vm.data.cabangId) {
            vm.dataEdit.cabangIdEdit = vm.dataCabang[i];
          }
        }
        // console.log("edit", vm.data);
        // vm.dataEdit.koordinatorIdEdit = "";
        // vm.dataEdit.capemIdEdit = "";
        vm.dataEdit.nomorSuratPerintah = vm.data.nomorSuratPerintah;
        vm.dataEdit.tanggalKontrak = new Date(vm.data.tanggalKontrak);
        vm.dataEdit.masaBerlakuKontrak = vm.data.masaBerlakuKontrak;
        vm.dataEdit.jatuhTempoKontrak = new Date(vm.data.jatuhTempoKontrak);
        vm.dataEdit.suratPerjanjianKerjaId = vm.data.suratPerjanjianKerjaId;
        vm.dataEdit.dataKaryawanId = vm.data.dataKaryawanId;
        vm.dataEdit.namaPejabatManajemen = vm.data.namaPejabatManajemen;
        vm.noSuratPerjanjian = vm.data.nomorSuratPerjanjian;
        vm.dataEdit.penempatan = vm.data.penempatan;
        // vm.getKoordinator(vm.dataEdit.mitraIdEdit);
        vm.getManajemens();
        // vm.getCabang();
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataEdit[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    // async getKoordinator(x) {
    //   const vm = this;
    //   let koordinator = await vm.$axios.get("/koordinator/listKoordinatorByMitraId/" + x.id);
    //   vm.koordinator = koordinator.data.data;
    //   for (let i = 0; i < vm.koordinator.length; i++) {
    //     if (vm.koordinator[i].koordinatorId == vm.data.koordinatorId) {
    //       vm.dataEdit.koordinatorIdEdit = vm.koordinator[i];
    //     }
    //   }
    //   vm.getCabang(vm.dataEdit.koordinatorIdEdit);
    // },
    // async getKoordinators(x) {
    //   const vm = this;
    //   let koordinator = await vm.$axios.get("/koordinator/listKoordinatorByMitraId/" + x.id);
    //   vm.koordinator = koordinator.data.data;
    //   vm.dataEdit.koordinatorIdEdit = "";
    //   vm.dataEdit.cabangIdEdit = "";
    //   vm.dataEdit.capemIdEdit = "";
    // },
    // async getCabang(x) {
    //   x;
    //   const vm = this;
    //   // let cabang = await vm.$axios.get("/cabang/listCabangByKoordinatorId/" + x.id);
    //   let cabang = await vm.$axios.get("/cabang/list");
    //   console.log(cabang, "ini cabang");
    //   vm.cabang = cabang.data.data;
    //   for (let i = 0; i < vm.cabang.length; i++) {
    //     if (vm.cabang[i].cabangId == vm.data.cabangId) {
    //       vm.dataEdit.cabangIdEdit = vm.cabang[i];
    //     }
    //   }
    //   // vm.getCapem(vm.dataEdit.cabangIdEdit);
    // },
    // async getCabangs(x) {
    //   const vm = this;
    //   let cabang = await vm.$axios.get(
    //     "/cabang/listCabangByKoordinatorId/" + x.id
    //   );
    //   vm.cabang = cabang.data.data;
    //   vm.dataEdit.cabangIdEdit = "";
    //   vm.dataEdit.capemIdEdit = "";
    // },
    // async getCapem(x) {
    //   const vm = this;
    //   let capem = await vm.$axios.get("/capem/listCapemByCabangId/" + x.id);
    //   vm.capem = capem.data.data;
    //   for (let i = 0; i < vm.capem.length; i++) {
    //     if (vm.capem[i].capemId == vm.data.capemId) {
    //       vm.dataEdit.capemIdEdit = vm.capem[i];
    //     }
    //   }
    // },
    // async getCapems(x) {
    //   const vm = this;
    //   let capem = await vm.$axios.get("/capem/listCapemByCabangId/" + x.id);
    //   vm.capem = capem.data.data;
    //   vm.dataEdit.capemIdEdit = "";
    // },
    async getManajemens() {
      const vm = this;
      let manajemen = await vm.$axios.get("/masterManajemen/list");
      vm.manajemen = manajemen.data.data;
      // console.log(vm.manajemen, vm.data, "jemen");

      for (let i = 0; i < vm.manajemen.length; i++) {
        if (vm.manajemen[i].jabatanManajemen == vm.data.posisiManajemen) {
          vm.dataEdit.posisiManajemenId = vm.manajemen[i];
        }
      }
    },
    setExpire() {
      let vm = this;
      vm.dataEdit.jatuhTempoKontrak = vm
        .$moment(vm.dataEdit.tanggalKontrak)
        .add(vm.dataEdit.masaBerlakuKontrak, "month")
        .subtract(1, "days");
      vm.place = vm
        .$moment(vm.dataEdit.tanggalKontrak)
        .add(vm.dataEdit.masaBerlakuKontrak, "month")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
    },
    setPenempatan() {
      let vm = this;
      // console.log(vm.dataEdit.mitraIdEdit, "mitra");
      // if (vm.dataEdit.capemIdEdit) {
      //   vm.dataEdit.penempatan = vm.dataEdit.capemIdEdit.namaCapem;
      // } else {
        if (vm.dataEdit.cabangIdEdit) {
          vm.dataEdit.penempatan = vm.dataEdit.cabangIdEdit.namaCabang;
        } 
        // else {
        //   if (vm.dataEdit.koordinatorIdEdit) {
        //     vm.dataEdit.penempatan =
        //       vm.dataEdit.koordinatorIdEdit.namaKoordinator;
        //   } else {
        //     vm.dataEdit.penempatan = vm.dataEdit.mitraIdEdit.namaMitra;
        //   }
        // }
      // }
    },
    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.dataEdit.id = vm.data.poolKontrakId;
      // vm.dataEdit.mitraId = vm.dataEdit.mitraIdEdit.id;
      // vm.dataEdit.koordinatorId = vm.dataEdit.koordinatorIdEdit.koordinatorId;
      // vm.dataEdit.capemId = vm.dataEdit.capemIdEdit.capemId;
      vm.dataEdit.cabangId = vm.dataEdit.cabangIdEdit.cabangId;
      vm.dataEdit.tanggalKontrak = vm.$moment(vm.dataEdit.tanggalKontrak);
      vm.dataEdit.jatuhTempoKontrak = vm.$moment(vm.dataEdit.jatuhTempoKontrak);
      console.log(vm.dataEdit, "ini data edit");
      vm.$axios
        .post("/poolKontrak/update", vm.dataEdit)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGUBAH KONTRAK KARYAWAN",
              showing: true,
            });
            this.$bvModal.hide("modal-edit");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
